import { render } from "./Our_Services.vue?vue&type=template&id=54b75af3&scoped=true"
import script from "./Our_Services.vue?vue&type=script&lang=js"
export * from "./Our_Services.vue?vue&type=script&lang=js"

import "./Our_Services.vue?vue&type=style&index=0&id=54b75af3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b75af3"]])

export default __exports__